module.exports = __webpack_public_path__ + "assets/7d9f6ac5fb87a19596c6142230eb0df5.mp3";